// extracted by mini-css-extract-plugin
var _1 = "qQ9ktbDe5dGKJ8Y5uXmQ";
var _2 = "sVoGVw0Ga7_nn5X2g3Ug";
var _3 = "#000000";
var _4 = "#76F366";
var _5 = "#EB8632";
var _6 = "#ECC834";
var _7 = "#21FC87";
var _8 = "#EA4A30";
var _9 = "#C7EA45";
var _a = "#272B2B";
var _b = "#BDBDBD";
var _c = "#7D7D7D";
var _d = "#6A0DAD";
var _e = "#3A65FF";
var _f = "#4A90E2";
var _10 = "#ffffff";
var _11 = "sIPGRqSrqs1TTCct0eww";
var _12 = "c3Pbu7dEabYBSToLyepx";
var _13 = "jvS3GI0DcEYKlCS9Yvkv";
var _14 = "KtJbRAHPd0g80VgVhYj1";
var _15 = "OxLzayHLPalobg3mJ2MH";
var _16 = "zj_uJBBzKo3TeW98JWnj";
var _17 = "zeewqfqBfZFn9LBTTYox";
var _18 = "vmzQQ7oo5bU75St62hlW";
var _19 = "1200px";
var _1a = "992px";
var _1b = "1366px";
var _1c = "768px";
var _1d = "1475px";
var _1e = "576px";
var _1f = "1600px";
var _20 = "320px";
var _21 = "2500px";
var _22 = "d2DgfEuJXKIRxBNvbRvP";
var _23 = "eczHyU0ieFFXxaP_5DxK";
export { _1 as "active-media-preview", _2 as "base-link", _3 as "colorBlack", _4 as "colorGradeEX", _5 as "colorGradeFR", _6 as "colorGradeGD", _7 as "colorGradeOU", _8 as "colorGradePR", _9 as "colorGradeVG", _a as "colorNeutral", _b as "colorNeutralLighest", _c as "colorNeutralLight", _d as "colorNonOwnerSweetLine", _e as "colorOwnerSweetLine", _f as "colorRegularLinks", _10 as "colorWhite", _11 as "iconMore", _12 as "menuItem", _13 as "menuItemIcon", _14 as "moreContainer", _15 as "pinIcon", _16 as "pinNavItem", _17 as "pinPopup", _18 as "reset-button", _19 as "screenlg", _1a as "screenmd", _1b as "screenml", _1c as "screensm", _1d as "screenxlg", _1e as "screenxs", _1f as "screenxxlg", _20 as "screenxxs", _21 as "screenxxxlg", _22 as "single-page-responsive-font-size", _23 as "textContainer" }
export default { "active-media-preview": _1, "base-link": _2, "colorBlack": _3, "colorGradeEX": _4, "colorGradeFR": _5, "colorGradeGD": _6, "colorGradeOU": _7, "colorGradePR": _8, "colorGradeVG": _9, "colorNeutral": _a, "colorNeutralLighest": _b, "colorNeutralLight": _c, "colorNonOwnerSweetLine": _d, "colorOwnerSweetLine": _e, "colorRegularLinks": _f, "colorWhite": _10, "iconMore": _11, "menuItem": _12, "menuItemIcon": _13, "moreContainer": _14, "pinIcon": _15, "pinNavItem": _16, "pinPopup": _17, "reset-button": _18, "screenlg": _19, "screenmd": _1a, "screenml": _1b, "screensm": _1c, "screenxlg": _1d, "screenxs": _1e, "screenxxlg": _1f, "screenxxs": _20, "screenxxxlg": _21, "single-page-responsive-font-size": _22, "textContainer": _23 }
